import React from 'react'
import classnames from 'classnames'
import DismissibleBanner, {
  DismissibleBannerProps,
} from '../../../components/DismissibleBanner'
import FadeOut, { FadeOutProps } from '../../../components/transitions/FadeOut'
// @ts-ignore
import css from './post-view.scss'
import { InfoButton } from '../../../components/buttons'
import { newRegistryPath } from '../../../lib/urls'

import SignUpBannerCss from './signUpBanner.scss'
import usePosition from './usePosition'
import { bowserFlags } from '../../../lib/bowser'

export default function SignUpBanner({
  show,
  onClose,
}: Pick<FadeOutProps & DismissibleBannerProps, 'show' | 'onClose'>) {
  const positionStyle = usePosition(bowserFlags.mobile ? 52 : 0)

  return (
    <FadeOut
      animateOnEnter={false}
      className={classnames(SignUpBannerCss.root, SignUpBannerCss.sticky)}
      show={show}
      // Put the component on top of the Solvvy button
      style={{ ...positionStyle, zIndex: 9999999999 }}
    >
      <DismissibleBanner onClose={onClose} role="banner">
        <InfoButton
          className={css.startNewRegButton}
          href={newRegistryPath + SignUpBanner.Constants.TRACKING_URL_QUERY}
          pill
        >
          Start Your Registry
        </InfoButton>
      </DismissibleBanner>
    </FadeOut>
  )
}

SignUpBanner.Constants = {
  TRACKING_URL_QUERY: '?loc=Banner+Button',
}
